import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { Language } from '../config/siteContent'
import { routeFor } from '../config/routes'
import { siteConfig } from '../config/site'

type ActionMatch = {
  label: string
  href: string
  internal?: boolean
}

export default function InlineActionText({ text, language }: { text: string; language: Language }) {
  const actions: ActionMatch[] = language === 'el'
    ? [
        { label: 'φόρμα επικοινωνίας', href: `${routeFor(language, 'contact')}#contact-form`, internal: true },
        { label: 'email', href: `mailto:${siteConfig.contact.email}` },
        { label: 'τηλεφώνου', href: `tel:${siteConfig.contact.telephone}` },
        { label: 'τηλεφωνικά', href: `tel:${siteConfig.contact.telephone}` },
      ]
    : [
        { label: 'contact form', href: `${routeFor(language, 'contact')}#contact-form`, internal: true },
        { label: 'email', href: `mailto:${siteConfig.contact.email}` },
        { label: 'telephone', href: `tel:${siteConfig.contact.telephone}` },
        { label: 'phone', href: `tel:${siteConfig.contact.telephone}` },
      ]

  const nodes: ReactNode[] = []
  let cursor = 0

  while (cursor < text.length) {
    const remaining = text.slice(cursor)
    const matches = actions
      .map((action) => ({ action, index: remaining.toLocaleLowerCase(language).indexOf(action.label.toLocaleLowerCase(language)) }))
      .filter((match) => match.index >= 0)
      .sort((a, b) => a.index - b.index)
    const match = matches[0]

    if (!match) {
      nodes.push(remaining)
      break
    }

    if (match.index > 0) nodes.push(remaining.slice(0, match.index))
    const label = remaining.slice(match.index, match.index + match.action.label.length)
    const key = `${cursor}-${match.action.href}`
    nodes.push(match.action.internal
      ? <Link className="inline-action-link" to={match.action.href} key={key}>{label}</Link>
      : <a className="inline-action-link" href={match.action.href} key={key}>{label}</a>)
    cursor += match.index + match.action.label.length
  }

  return <>{nodes}</>
}
